export default (str) =>
  str
    .split(' ')
    .reduce((acc, item, i) => (i < 2 ? [...acc, item.slice(0, 1).toUpperCase()] : acc), [])
    .join('')
